import { Outlet, Navigate, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";

const ProtectedRoute = () => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
    const API_URL = `${process.env.REACT_APP_API_URL}`;
    const location = useLocation();


    useEffect(() => {
        axios.get(`${API_URL}/verify-token`, { withCredentials: true })
            .then(response => {
                if (response.status === 200) {
                    setIsAuthenticated(true);
                }
            })
            .catch((error) => {
                setIsAuthenticated(false);
            });
    }, [location]);

    if (isAuthenticated === null) {
        return <div className="min-h-screen bg-white flex flex-col items-center justify-center">
            <div className="w-6 h-6 border-4 border-t-blue-500 border-white rounded-full animate-spin"></div>
            <h1 className="text-xl font-medium  mt-4 text-gray-800">Checking Client..</h1>
        </div>
    }

    return isAuthenticated ? <Outlet /> : <Navigate to="/admin" />;
};

export default ProtectedRoute;
